export default {"src":"/_next/static/media/background.3a675304.svg","height":896,"width":414};